<p-dialog
  #httpRequestItemsModal
  modal="true" [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header"> </ng-template>
  <div class="row">
    <div class="col-sm-12">
      <button pButton type="button" class="btn btn-primary" (click)="refresh()">{{ 'common.refresh' | translate | titlecase }}</button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <p-table [showGridlines]="true" #requestItemsDataTable [rows]="requestItems.length" [value]="requestItems" [paginator]="false" (onLazyLoad)="refresh()" [lazy]="true">
        <ng-template let-dataItem pTemplate="body">
          <tr>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.Url }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.InProgress }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.Completed }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.EnableCaching }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.CacheExpires }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.SlidingCache }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.SlidingCacheSeconds }}</span>
            </td>
            <td>
              <span style="word-wrap: break-word">{{ dataItem.PrimaryRequest }}</span>
            </td>
            <td>
              <button pButton type="button" class="btn btn-default" (click)="removeRequestItem(dataItem)">
                {{ 'common.remove' | translate | titlecase }}
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center">
              {{ 'common.phrases.no-results-found' | translate | titlecase }}
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="btn btn-primary" (click)="close()">{{ 'common.close' | translate | titlecase }}</button>
  </ng-template>
</p-dialog>
